// Panel de alertas de stock. Port de views/alertas.js.
import { Link } from '@tanstack/react-router';
import { useAlertas } from '../hooks/useAlertas';
import { StatCard } from '../components/StatCard';
import { NivelBadge } from '../components/Badge';
import { Thumb } from '../components/Thumb';
import { SkeletonTable } from '../components/Skeletons';
import { ErrorBox } from '../components/ErrorBox';

export function Alertas() {
  const { data: alertas, isLoading, isError, error, refetch } = useAlertas();

  if (isLoading) {
    return (<><div className="page-head"><h2>Alertas</h2></div><SkeletonTable rows={5} /></>);
  }
  if (isError || !alertas) {
    return (<><div className="page-head"><h2>Alertas</h2></div><ErrorBox mensaje={(error as Error)?.message ?? 'Error'} /></>);
  }

  const agotados = alertas.filter((a) => a.tipo === 'agotado');
  const bajos = alertas.filter((a) => a.tipo === 'bajo');

  return (
    <>
      <div className="page-head">
        <h2>Alertas de stock</h2>
        <button className="btn outline sm" onClick={() => refetch()}><i className="fa-solid fa-rotate" /> Actualizar</button>
      </div>

      <div className="grid cols-2" style={{ marginBottom: 20 }}>
        <StatCard icon="fa-ban" color="danger" label="Productos agotados" value={agotados.length} desc="Requieren reposición inmediata" />
        <StatCard icon="fa-arrow-trend-down" color="warning" label="Stock bajo" value={bajos.length} desc="Por debajo del mínimo" />
      </div>

      {alertas.length ? (
        <div className="card table-card">
          <div className="table-toolbar">
            <span className="chip c-danger" style={{ width: 34, height: 34 }}><i className="fa-solid fa-bell" /></span>
            <h3>Detalle de alertas</h3>
          </div>
          <div className="table-wrap">
            <table className="data">
              <thead>
                <tr><th>Producto</th><th>Bodega</th><th>Stock</th><th>Mínimo</th><th>Estado</th><th></th></tr>
              </thead>
              <tbody>
                {alertas.map((a) => (
                  <tr key={`${a.bodega_id}-${a.item_id}`}>
                    <td><div className="cell-item"><Thumb icon="fa-box" /><b>{a.item_nombre}</b></div></td>
                    <td>{a.bodega || '—'}</td>
                    <td><b>{a.stock}</b></td>
                    <td>{a.stock_minimo}</td>
                    <td><NivelBadge nivel={a.tipo} /></td>
                    <td style={{ textAlign: 'right' }}>
                      <Link to="/inventario" className="btn ghost sm"><i className="fa-solid fa-plus" /> Reponer</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="empty-state">
            <i className="fa-solid fa-circle-check" style={{ color: 'var(--success)' }} />
            <b>¡Todo en orden!</b><br /><small>No hay productos agotados ni por debajo del mínimo.</small>
          </div>
        </div>
      )}
    </>
  );
}
